/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Typography, Grid } from '@mui/material';
import { WorkOrdersAutoBulkContext } from '../contexts/WorkOrdersAutoBulkContext';
import { MachinesContext } from '../../../modules/machinesAdminManagement/contexts/MachinesContext';
import WorkOrderAutoBulkForm from '../components/WorkOrdersAutoBulkForm';
import Breadcrumbs from '../../../modules/navigation/components/Breadcrumbs';

const WorkOrdersAutoBulkCreate: React.FunctionComponent = () => {
  const [initialDataLoaded, setDataLoaded] = React.useState(false);
  const { fetchWorkOrdersAutoBulk, setCreatingPage, activeMachine } = React.useContext(WorkOrdersAutoBulkContext);
  const [fitlerBarActive, setFitlerBarActive] = React.useState(true);
  const { fetchAutoBulkMachines, autoBulkMachines, machinesLoading } = React.useContext(MachinesContext);

  React.useEffect(() => {
    const getMachines = async () => {
      if (!initialDataLoaded) {
        setDataLoaded(true);

        fetchAutoBulkMachines();
      }
    };

    getMachines();
  }, [initialDataLoaded, setDataLoaded, fetchWorkOrdersAutoBulk]);

  const links = [
    {
      onClick: () => setCreatingPage(false),
      text: `${activeMachine?.label}`,
    },
    {
      onClick: () => null,
      text: `Create`,
    },
  ];

  return (
    <>
      <Grid justifyContent="space-between" container spacing={3}>
        <Grid item>
          <Typography
            style={{ marginBottom: 10, color: '#333', opacity: 0.6, cursor: 'pointer' }}
            onClick={() => {
              setCreatingPage(false);
            }}
          >
            ← Return to Order List
          </Typography>
          <Breadcrumbs links={links} />
        </Grid>
      </Grid>
      <br />
      <Typography variant="h1" component="h1">
        Create WorkOrder
      </Typography>
      <br />
      <WorkOrderAutoBulkForm
        workOrder={{}}
        machineSerial={activeMachine?.value}
        onSuccess={() => setCreatingPage(false)}
      />
    </>
  );
};

export default WorkOrdersAutoBulkCreate;
